/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Nav_NewsInputs */

const en_fw_nav_news = /** @type {(inputs: Fw_Nav_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

const zh_fw_nav_news = /** @type {(inputs: Fw_Nav_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Fw_Nav_NewsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_nav_news = /** @type {((inputs?: Fw_Nav_NewsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Nav_NewsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_nav_news(inputs)
	return zh_fw_nav_news(inputs)
});
export { fw_nav_news as "fw.nav.news" }